import { Box, CircularProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Startup from '../../../models/startup'
import { fetchStartupDetails, getdownloadLink } from '../../../networking/network'
import { useAppSelector } from '../../../store/hooks'
import StartupDetailsView from './details/StartupDetailsView'

interface Props {
  
}

const StartupDetailsContainer = (props: Props) => {
  const accessToken = useAppSelector(state => state.user.token)

  const { id } = useParams()  

  const navigation = useNavigate()

  const [startup, setStartup] = useState<undefined | Startup>(undefined)
  const [logoUrl, setLogoUrl] = useState<undefined | string>(undefined)
  const [deckUrl, setDeckUrl] = useState<undefined | string>(undefined)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!id) {
      return
    }
    const fetchStartup = async () => {
      if (!accessToken) {
        return
      }
      const startupDetails = await fetchStartupDetails(accessToken, id)
      if (startupDetails.logoUrl) {
        const logo = await getdownloadLink(accessToken, startupDetails.logoUrl)
        setLogoUrl(logo)
      }
      if (startupDetails.deckUrl) {
        const deck = await getdownloadLink(accessToken, startupDetails.deckUrl)
        setDeckUrl(deck)
      }

      setIsLoading(false)
      setStartup(startupDetails)      
    }
    fetchStartup()
  }, [])

  return (
    <Box sx={{
      padding: 2
    }}>
      {isLoading &&
        <CircularProgress />
      }
      {!isLoading && startup &&
        <StartupDetailsView 
          startup={startup} 
          logoUrl={logoUrl} 
          deckUrl={deckUrl} 
          onEditStartupPressed={() => {
            navigation(`/startups/${startup.id}/edit`)
          }} 
          onRateStartupPressed={() => {
            navigation(`/startups/${startup.id}/score`)
          }} 
          onViewAllScoresPressed={() => {
            navigation(`/startups/${startup.id}/scores`)
          }}
        />
      }
    </Box>
  )
}

export default StartupDetailsContainer
